var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _circle, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBasketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 87,
    viewBox: "0 0 76 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7119 12C58.1464 12 74.7119 28.5655 74.7119 49C74.7119 69.4345 58.1464 86 37.7119 86C17.2774 86 0.711914 69.4345 0.711914 49C0.711914 28.5655 17.2774 12 37.7119 12Z",
    stroke: "#ADADAD",
    strokeDasharray: 9.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5767 37.4547L27.2719 55.2347H49.6198C50.9669 55.2347 52.1701 54.3826 52.6302 53.1027L57.6144 39.2412C57.9932 38.1881 57.2216 37.0749 56.1135 37.0749H21.3771L17.3462 33H14.7119",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.7725,
    cy: 66.0998,
    rx: 2.86869,
    ry: 2.90005,
    fill: "#DEDEDE",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.9825,
    cy: 66.0998,
    rx: 2.86869,
    ry: 2.90005,
    fill: "#DEDEDE",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2715 55.2344L28.6426 60.1518H50.1544",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7592 40.7754L49.1021 51.3244H45.3608",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.7119,
    cy: 20,
    r: 14,
    fill: "#707070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7047 26.192C62.8087 26.192 63.8327 23.568 63.8327 20.304C63.8327 17.04 62.8087 14.448 59.7047 14.448C56.6007 14.448 55.5927 17.04 55.5927 20.304C55.5927 23.568 56.6007 26.192 59.7047 26.192ZM59.7047 24.304C58.1527 24.304 57.7047 22.544 57.7047 20.304C57.7047 18.096 58.1527 16.352 59.7047 16.352C61.2567 16.352 61.7047 18.096 61.7047 20.304C61.7047 22.544 61.2567 24.304 59.7047 24.304Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71336 21H18.6354V18.624H13.5314C12.8054 18.624 12.4754 18.69 12.4754 18.69V18.646C12.4754 18.646 12.9374 18.25 13.4434 17.612L18.4814 11.298V9.78H8.93336V12.156H13.6634C14.3674 12.156 14.6974 12.112 14.6974 12.112V12.156C14.6974 12.156 14.2574 12.552 13.7514 13.19L8.71336 19.504V21Z",
    fill: "#707070"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5766 30H27.7926V28.272H24.0806C23.5526 28.272 23.3126 28.32 23.3126 28.32V28.288C23.3126 28.288 23.6486 28 24.0166 27.536L27.6806 22.944V21.84H20.7366V23.568H24.1766C24.6886 23.568 24.9286 23.536 24.9286 23.536V23.568C24.9286 23.568 24.6086 23.856 24.2406 24.32L20.5766 28.912V30Z",
    fill: "#707070"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBasketIcon);
export default __webpack_public_path__ + "static/media/empty-basket-icon.0ba11c98319908a830bc04b0732b7b38.svg";
export { ForwardRef as ReactComponent };